module.exports = __webpack_public_path__ + "img/parliament-5.d548741b.webp";